import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { WarningToastComponent } from '@components/toasts/warning-toast/warning-toast.component';
import { IToast } from '@interfaces/toast.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private _toasts: BehaviorSubject<IToast> = new BehaviorSubject<IToast>(null);

  public get toasts(): Observable<IToast> {
    return this._toasts.asObservable();
  }

  showErrorToast(message: string, delay: number = 5000) {
    this._toasts.next({
      component: WarningToastComponent,
      toastData: {
        delay,
        data: { message },
        callback: () => {}
      }
    });
  }
}
